import { render } from "./error-layer.vue?vue&type=template&id=fb66d728"
import script from "./error-layer.vue?vue&type=script&lang=js"
export * from "./error-layer.vue?vue&type=script&lang=js"

import "./error-layer.vue?vue&type=style&index=0&id=fb66d728&lang=less"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__